module.exports = __webpack_public_path__ + "static/img/game_over.f81693b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game_over.png
// module id = Ib5F
// module chunks = 0